import React, { useContext, useMemo } from "react";
import { EntityIdentifier } from "module/entity/types";
import { getEntityIdentifierKey } from "module/entity/helper/getEntityIdentifierKey";
import MaintenanceTaskContext from "module/maintenanceTask/context/MaintenanceTaskContext";
import { MaintenanceTaskInterface } from "module/maintenanceTask/types";
import EntityContextProvider from "module/entity/context/entity/EntityContextProvider";
import { MaintenanceTaskPersonnelAssignmentInternalStaffInterface } from "module/maintenanceTaskPersonnelAssignment/internalStaff/types";
import MaintenanceTaskPersonnelAssignmentInternalStaffContext from "module/maintenanceTaskPersonnelAssignment/internalStaff/context/MaintenanceTaskPersonnelAssignmentInternalStaffContext";

interface Props {
  entityIdentifier: EntityIdentifier;
  children: React.ReactNode;
}

const MaintenanceTaskPersonnelAssignmentInternalStaffContextProvider: React.FC<Props> =
  ({ entityIdentifier, children }) => {
    const { entity } = useContext(MaintenanceTaskContext);

    const maintenanceTask = entity as MaintenanceTaskInterface;

    const internalStaff = useMemo(
      () =>
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        maintenanceTask.relationships.get(entityIdentifier)
          .data as MaintenanceTaskPersonnelAssignmentInternalStaffInterface,
      [entityIdentifier, maintenanceTask.relationships]
    );
    return (
      <EntityContextProvider
        {...{
          entity: internalStaff,
          context: MaintenanceTaskPersonnelAssignmentInternalStaffContext,
          key: getEntityIdentifierKey(entityIdentifier),
        }}
      >
        {children}
      </EntityContextProvider>
    );
  };

export default MaintenanceTaskPersonnelAssignmentInternalStaffContextProvider;
